var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 3.62891C6.77573 3.62891 4.16406 6.24057 4.16406 9.46224C4.16406 10.4939 4.44239 11.4764 4.94572 12.3531C4.95489 12.3697 6.52406 14.8356 6.66406 15.2956H13.3307C13.4682 14.8381 15.0324 12.3897 15.0232 12.4047C15.5424 11.5189 15.8307 10.5106 15.8307 9.46224C15.8307 6.24057 13.2191 3.62891 9.9974 3.62891ZM9.9974 6.96224C10.4574 6.96224 10.8307 7.33557 10.8307 7.79557C10.8307 8.25557 10.4574 8.62891 9.9974 8.62891C9.5374 8.62891 9.16406 9.00224 9.16406 9.46224C9.16406 9.92224 8.79073 10.2956 8.33073 10.2956C7.87073 10.2956 7.4974 9.92224 7.4974 9.46224C7.4974 8.08141 8.61656 6.96224 9.9974 6.96224ZM6.66406 16.9622C6.66406 18.8031 8.15656 20.2956 9.9974 20.2956C11.8382 20.2956 13.3307 18.8031 13.3307 16.9622H6.66406Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.5274e3ba8577bb477ed3b0f7c777c8df.svg";
export { ForwardRef as ReactComponent };